import { Alert, Box, Grid } from '@mui/material'

type Props = {
  message: string
}

/**
 * This component can be used when a page has an error and cannot load
 */
export const PageError = ({ message }: Props) => {
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Grid container spacing={2} sx={{ height: '100%', justifyContent: 'center', alignItems: 'center' }}>
        <Grid>
          <Alert variant="outlined" severity="error">
            {message}
          </Alert>
        </Grid>
      </Grid>
    </Box>
  )
}
